import React from 'react';
import './List.scss';

const List = ({children, type = 'default'}) => {
  return <div className={`list list--${type}`}>{children}</div>;
};

export default List;
